import { RootState } from "redux/rootReducer";

export const selectIsLoadingConsentStatement = (state: RootState) =>
  state.consentStatement.loading;
export const selectConsentStatementErrorMessage = (state: RootState) =>
  state.consentStatement.error;
export const consentStatementDataResponse = (state: RootState) =>
  state.consentStatement.consentStatementResponse;
